/* BuildBadgeCTA — drop-in section that points the user to the Build Badge
   brief for a given role.  Slugifies the passed role name the same way the
   build-briefs.json normalizer does, so the link is stable. */
import React from 'react';
import { Link } from 'react-router-dom';
import { Trophy, ArrowRight } from 'lucide-react';

const slugify = (name = '') => name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 80);

const BuildBadgeCTA = ({ roleName, program = '', label }) => {
  const target = program ? `${program}-${roleName}` : roleName;
  const slug = slugify(target);
  return (
    <div
      className="my-10 rounded-3xl bg-gradient-to-br from-amber-500 via-orange-500 to-rose-500 text-white p-6 md:p-8 shadow-xl"
      data-testid="role-build-badge-cta"
    >
      <div className="flex items-start gap-4 flex-wrap">
        <span className="inline-flex w-12 h-12 rounded-2xl bg-white/15 backdrop-blur items-center justify-center shrink-0">
          <Trophy size={22} />
        </span>
        <div className="flex-1 min-w-[220px]">
          <span className="text-[10px] font-extrabold tracking-widest uppercase bg-white/15 px-2 py-0.5 rounded-full">
            Build Badge · Free · Bronze tier
          </span>
          <h3 className="text-xl md:text-2xl font-black mt-2 mb-1">
            Get the Build Badge for {label || roleName}
          </h3>
          <p className="text-white/90 text-[14px] md:text-[15px] leading-relaxed">
            Don&rsquo;t just read about this role — <strong>build a small project that proves you can do it.</strong> AI-reviewed in seconds. Sharable on LinkedIn forever.
          </p>
        </div>
        <Link
          to={`/builds/${slug}`}
          data-testid="role-build-badge-link"
          className="inline-flex items-center gap-2 bg-white text-amber-700 font-extrabold px-5 py-3 rounded-full hover:bg-amber-50 transition-colors shrink-0"
        >
          See the brief <ArrowRight size={15} />
        </Link>
      </div>
    </div>
  );
};

export default BuildBadgeCTA;
